import {
  audienceAssociationSectionStyle,
  commonDoubleListBoxStyle,
  convertToLocalStyle,
  glyphIconStyle,
  helpbuttonStyle,
  paginationStyle,
  searchboxStyle,
} from '@bingads-webui-campaign-react/common-styles';

export const getAudiencePickerStyle = (_, { palette = {} }) => ({
  pickerContainer: {
    '& .ms-Panel-content': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      overflowY: 'auto',

      '& .audience-description': {
        margin: '16px 0',
      },

      '& .audience-association-view': {
        ...audienceAssociationSectionStyle({ palette }, { singleListBoxWidth: 450 }),
        ...commonDoubleListBoxStyle({ palette }),
        ...paginationStyle({ palette }),
        ...searchboxStyle({ palette }),
        ...convertToLocalStyle(glyphIconStyle({ palette })),
        ...convertToLocalStyle(helpbuttonStyle({ palette })),

        '& .association__header, .audience__exclusion, .create-audience-link-section': {
          display: 'none',
        },

        '& .association-section, .audience__association, .audience__exclusion': {
          '& .DMP_doublelistbox_section .doubleListBox.layout-columns': {
            width: 920,

            '& .form-group, .layout-columns-element:nth-child(1) .form-group:nth-child(1) .dlb-filter-alignPlaceholder .form-control-feedback': {
              margin: 0,
            },
          },

          '& .row': {
            margin: 0,
          },
        },

        '& .selectable-treeview ul': {
          listStyleType: 'none',
          padding: 0,
        },

        '&.InMarket, &.CustomerList': {
          '& .dmp_select_section': {
            display: 'none',
          },
        },
      },
    },

    '& .ms-Panel-footer': {
      backgroundColor: palette.white,
      borderTop: `1px solid ${palette.neutralLight}`,

      '& .audience-picker-buttons': {
        display: 'flex',
        flexDirection: 'row',
        gap: '8px',
      },
    },
  },
});
